import React from "react";

import { compareAsc, formatDate } from "date-fns";

import { FormattedDateDisplay } from "src/components/timeZone/formattedDateDisplay";
import { Constants } from "src/utils/constants";

import { BaseDataType } from "./dataType";
import { FORMAT, FORMATS } from "./dateFormats";

/**
 * import { format } from "date-fns";
 *
 * format(new Date(), FORMAT.FULL); -> Mon Jan 28, 2024, 12:22:22 AM
 * format(Date().now(), FORMAT.LONG); -> Jan 22, 2024, 03:15:22 AM
 * format(dt, FORMAT.SHORT); -> 12/22/2024 03:15:22 AM
 * format(dt, FORMAT.MMDDYYYY); -> 12/22/2024
 * format(dt, FORMAT.MON_DD_YYYY); -> Dec 22, 2024
 */

export class DateType extends BaseDataType<Date | -1> {
  DateType = true;
  tag = "date-type";
  protected format: FORMATS;
  protected className: string;
  constructor(
    value: Date | -1 = -1,
    format: FORMATS = FORMAT.LONG,
    className: string = "date-type"
  ) {
    super(value);
    this.format = format;
    this.className = className;
  }
  compare(a: DateType): number {
    if (this.value instanceof Date) {
      if (a.valueOf() instanceof Date) {
        // If the value of both is a Date then compare
        return compareAsc(this.value, a.valueOf());
      }
      // if the passed in value is not a date then we bubble up
      return 1;
    }
    if (a.valueOf() instanceof Date) {
      // if the passed in value is a date but this value is not then we bubble down
      return -1;
    }
    // if neither are dates then just return 0
    return 0;
  }
  valueOf(): Date | -1 {
    return this.value ?? -1;
  }
  setFormat(format: FORMATS) {
    this.format = format;
  }
  toString(): string {
    if (this.value instanceof Date) {
      return formatDate(this.value, this.format);
    }
    return Constants.EMPTY_VALUE;
  }
  render(): React.ReactElement {
    return (
      <FormattedDateDisplay
        value={this.value}
        format={this.format}
        className={`${this.className} mds-text-p3`}
        showTimeZone={false}
      />
    );
  }
}
